<template>
<div class="container">
    <div v-if="step=='loading'" class="row">
        <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
        <div class="card card-signin my-5">
            <div class="card-body">
                    <font-awesome-icon :icon="['fas', 'spinner']" spin size="6x"/>
            </div>
        </div>
        </div>
    </div>
    <div v-if="step == 'error'" class="row">
      <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
        <div class="card card-signin my-5">
            <div class="card-body">
                <h5 class="card-title text-center">{{$t('Erreur suppression de votre compte géoportail')}}</h5>
                <p class="card-text">{{$t('Une erreur est survenue lors de la suppression de votre compte.')}}
                    {{$t('Veuillez réessayer ultérieurement ou si le problème persiste contacter support@geoportail.lu')}}
                </p>
            </div>
            <p class="forgot-password text-right mt-2 mb-4">
                <router-link to="/">{{$t("Retour à l'écran de connexion")}}</router-link> |
            </p>
        </div>
      </div>
    </div>
    <div v-if="step=='success'" class="row">
      <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
        <div class="card card-signin my-5">
            <div class="card-body">
                <h5 class="card-title text-center">{{$t('Suppression de votre compte géoportail')}}</h5>
                <p class="card-text">{{$t('Votre compte est maintenant supprimé.')}}
                </p>
            </div>
            <p class="forgot-password text-right mt-2 mb-4">
                <router-link to="/">{{$t("Retour à l'écran de connexion")}}</router-link> |
            </p>
        </div>
      </div>
    </div>
    <div v-if="step=='expired'" class="row">
      <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
        <div class="card card-signin my-5">
            <div class="card-body">
            <h5 class="card-title text-center">{{$t('Suppression de votre compte géoportail impossible')}}</h5>
                <p class="card-text">
                {{$t('Votre lien de confirmation a expiré. Veuillez en regénérer un nouveau.')}}
            </p>
            <p class="forgot-password text-right mt-2 mb-4">
                <router-link to="/">{{$t("Retour à l'écran de connexion")}}</router-link> |
                <router-link to="/delete-account">{{$t('Générer un nouveau lien')}}</router-link>
            </p>
            </div>
        </div>
    </div>
    </div>
    <div v-if="step=='step1'" class="row">
      <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
        <div class="card card-signin my-5">
            <div class="card-body">
                <h5 class="card-title text-center">{{$t('Suppression de votre compte géoportail')}}</h5>
                <p class="card-text">{{$t("Vous venez de demander la suppression de votre compte géoportail et de toutes les données qui y sont associées.")}}
                        {{$t("La suppression d’un compte signifie que :")}}
                        <ul>
                        <li>{{$t("Le « nom d’utilisateur » sera à nouveau disponible pour un nouvel usage.")}}</li>
                        <li>{{$t("Pour des fins statistiques, vos données personnelles seront anonymisées. Vos nom, prénom et adresses n’apparaitront donc plus dans nos bases de données.")}}</li>
                        <li>{{$t("Si vous aviez passé des commandes avec ce compte, elles seront supprimées.")}}</li>
                        <li>{{$t("Si vous aviez des cartes mymaps enregistrées, elles seront supprimées.")}}</li>
                        </ul>
                        {{$t("Après la suppression du compte, nous ne serons plus en mesure de récupérer une ou plusieurs de ces informations, et il sera impossible de faire marche arrière.")}}
                        {{$t("La liste des comptes concerné est la suivante :")}}
                        <ul>
                            <li v-for="user in users" :key="user">
                                {{ user.login }}
                            </li>
                        </ul>
                </p>
                <div class="col-12 text-center mt-2 mt-md-4">
                <button class="btn btn-primary ml-2" @click="deleteaccount">{{$t("J'ai bien compris et je veux supprimer mon compte")}}</button>
                </div>
                <p class="forgot-password text-right mt-2 mb-4">
                    <router-link to="/">{{$t("Retour à l'écran de connexion")}}</router-link> |
                </p>
            </div>
        </div>
      </div>
    </div>
</div>
</template>

<script>
import { ref } from 'vue';
import { useRoute } from 'vue-router';
import i18n from "@/i18n"
export default {
    setup() {
        const step = ref("loading");
        const users = ref([]);
        const route = useRoute();
        var token = route.query.token;
        var lang = route.query.lang;
        if (lang !== undefined) {
            i18n.global.locale.value = lang;
        }
        let deleteTokenFormData = new FormData();
        deleteTokenFormData.append('token', token);
        deleteTokenFormData.append('lang', i18n.global.locale.value);
        fetch("api/checkdeletetokenvalidity", {
            body: deleteTokenFormData,
            method: "post"
        }).then(function(resp) {
            if (resp.ok === true) {
                resp.json().then(function(json) {
                    if (json.success == false) {
                        step.value = "expired";
                    } else {
                        users.value = json;
                        step.value = "step1"
                    }
                }.bind(this));
            } else {
                step.value = "error";
            }
        }.bind(this));
        const deleteaccount = function() {
            step.value = "loading";
            let formData = new FormData();
            formData.append('token', token);
            formData.append('lang', i18n.global.locale.value);
            fetch("api/deleteuser", {
                body: formData,
                method: "post"
            }).then(function(resp) {
                resp.json().then(function(status) {
                    if ('success' in status && status.success == true) {
                         step.value = "success";
                    } else {
                        step.value = "error";
                    }
                });
            });
            
        }
        // expose to template
        return {
            deleteaccount,
            users,
            step
        }
    }
}
</script>

<style>

</style>